if (!customElements.get('wellness-categories')) {
  customElements.define(
    'wellness-categories',
    class WellnessCategories extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.scroller = this.querySelector('[data-tab-scroller]');
        this.nav = this.querySelector('[data-tab-nav]');
        this.prev = this.querySelector('[data-tab-prev]');
        this.next = this.querySelector('[data-tab-next]');

        this.onScroll = () => this.updateArrows();
        this.onPrev = () => this.scrollTabs(-1);
        this.onNext = () => this.scrollTabs(1);
        this.onChange = (event) => {
          if (!event.target.matches('input[type="radio"]') || !event.target.checked) return;
          const tab = event.target.closest('.wellness-categories__tab');
          tab?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        };

        this.scroller?.addEventListener('scroll', this.onScroll, { passive: true });
        this.scroller?.addEventListener('change', this.onChange);
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);

        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        if (this.scroller) this.resizeObserver.observe(this.scroller);
        this.updateArrows();
        this.setupTapHint();
      }

      setupTapHint() {
        this.hint = this.querySelector('[data-tap-hint-marker]');
        const plays = parseInt(this.dataset.tapHint, 10);
        if (!this.hint || !plays) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const desktop = this.classList.contains('wellness-categories--hint-desktop');
        if (!desktop && window.matchMedia('(min-width: 990px)').matches) return;

        const tabs = Array.from(this.querySelectorAll('.wellness-categories__tab'));
        const target = tabs.find((tab) => !tab.querySelector('input:checked')) || tabs[0];
        if (!target) return;
        target.appendChild(this.hint);
        this.hint.style.setProperty('--wc-hint-plays', plays);

        this.stopHint = () => {
          this.hint?.classList.remove('is-playing');
          this.hintObserver?.disconnect();
          this.removeEventListener('change', this.stopHint);
        };
        this.addEventListener('change', this.stopHint);
        this.hint.addEventListener('animationend', (event) => {
          if (event.target.classList.contains('wellness-categories__hint-paw')) this.stopHint();
        });

        this.hintObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.hintObserver.disconnect();
            setTimeout(() => this.hint?.classList.add('is-playing'), 400);
          },
          { threshold: 0.5 }
        );
        this.hintObserver.observe(target);
      }

      disconnectedCallback() {
        this.scroller?.removeEventListener('scroll', this.onScroll);
        this.scroller?.removeEventListener('change', this.onChange);
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.resizeObserver?.disconnect();
        this.stopHint?.();
        this.initialized = false;
      }

      scrollTabs(direction) {
        if (!this.scroller) return;
        const amount = Math.max(180, this.scroller.clientWidth * 0.7);
        this.scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.scroller || !this.nav) return;
        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
        const overflows = maxScroll > 8;
        this.nav.hidden = !overflows;
        if (!overflows) return;
        if (this.prev) this.prev.disabled = this.scroller.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.scroller.scrollLeft >= maxScroll - 2;
      }
    }
  );
}
